var _IconArrowDown;
// import Modules
import React, { useEffect, useState, useRef, useMemo } from 'react';
import Box from '@mui/material/Box';
import { IconArrowDown } from "../../atoms/Icon";
import Typography from "../../atoms/Typography";

// import Styles
import colors from "../../theme/colors";
// import { CustomThemeType } from '~/theme';

// import Types
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DropdownQuantity = props => {
  const {
    maxQuantity = 15,
    currentQuantity,
    onSetQuantity = () => {},
    disableSelect = false,
    label = "Qty"
  } = props;
  const [expand, setExpand] = useState(false);
  const [current, setCurrent] = useState(currentQuantity);
  const refContent = useRef(null);
  useEffect(() => {
    setCurrent(currentQuantity);
  }, [currentQuantity]);
  useEffect(() => {
    const listMenu = refContent.current;
    if (listMenu && typeof window !== "undefined") {
      window.addEventListener("click", ev => {
        if (!listMenu.contains(ev.target) && ev) {
          setExpand(false);
        }
      });
    }
    ;
    return () => window.removeEventListener('click', () => {});
  }, []);
  const renderItems = useMemo(() => {
    const td = [];
    for (let i = 1; i <= maxQuantity; i += 1) {
      td.push( /*#__PURE__*/_jsx(Box, {
        onClick: () => {
          setCurrent(i);
          setExpand(false);
          onSetQuantity(i);
        },
        sx: {
          padding: '11px 16px',
          '&:hover': {
            background: 'rgba(221, 221, 221, 0.8)'
          }
        },
        children: i
      }, i));
    }
    return td;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxQuantity]);
  return /*#__PURE__*/_jsxs(Box, {
    ref: refContent,
    onClick: () => {
      setExpand(!expand);
    },
    sx: {
      display: 'flex',
      userSelect: 'none',
      alignItems: 'center',
      position: 'relative',
      border: `1px solid ${colors.neutral.neutral5}`,
      borderRadius: '30px',
      cursor: disableSelect ? '' : 'pointer',
      padding: {
        xs: '8.5px 15px 12.5px 12px ',
        md: '7.8px 20px 11.3px'
      },
      minWidth: {
        xs: '91px',
        md: '123px'
      },
      justifyContent: 'space-between'
    },
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "p5",
      children: label
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "p5",
      sx: {
        marginLeft: {
          xs: '13px',
          md: '25px'
        },
        marginRight: {
          xs: '9px',
          md: '8px'
        }
      },
      children: current
    }), !disableSelect && (_IconArrowDown || (_IconArrowDown = /*#__PURE__*/_jsx(IconArrowDown, {}))), !disableSelect && /*#__PURE__*/_jsx(Box, {
      sx: {
        display: expand ? 'block' : 'none',
        overflow: 'scroll',
        borderRadius: '12px',
        top: {
          xs: '45px',
          md: '50px'
        },
        position: 'absolute',
        zIndex: 1,
        background: 'rgba(237, 237, 237, 1)',
        width: {
          xs: '100%',
          md: '140px'
        },
        maxHeight: '240px',
        left: '0',
        '&::-webkit-scrollbar': {
          display: 'none'
        }
      },
      children: renderItems
    })]
  });
};
export default DropdownQuantity;